import { render, staticRenderFns } from "./NewFlight.vue?vue&type=template&id=e53ca910&"
import script from "./NewFlight.vue?vue&type=script&lang=js&"
export * from "./NewFlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports